export default "__VITE_ASSET__BTZZuHpc__"